import { Brief } from "./Show";
import type { PagyMetadata } from "@/components/pagination/PaginationControls";
import PaginationControls from "@/components/pagination/PaginationControls";
import PageHeader from "@/components/PageHeader";
import DataTable, { DataTableColumn } from "@/components/DataTable";
import { PageWithLayout, wideLayout } from "@/components/Layout";

interface IndexProps {
  briefs: Brief[];
  pagy: PagyMetadata;
}

const columns: DataTableColumn<Brief>[] = [
  {
    label: "Title",
    minWidth: "min-w-64",
    cellClassName: "font-medium",
    render: (brief) => brief.title,
  },
  {
    label: "Created At",
    minWidth: "min-w-32",
    cellClassName: "font-light",
    render: (brief) => new Date(brief.created_at).toLocaleDateString(),
  },
  {
    label: "Created By",
    minWidth: "min-w-40",
    cellClassName: "font-light",
    render: (brief) => brief.user.full_name,
  },
];

const Index: PageWithLayout<IndexProps> = ({ briefs, pagy }) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-10">
      <PageHeader
        title="All briefs"
        primaryAction={{ href: "/briefs/new", text: "New Brief" }}
      />
      <div className="flex w-full flex-col items-start justify-start gap-5">
        <DataTable
          columns={columns}
          rows={briefs}
          rowKey={(brief) => brief.id}
          rowHref={(brief) => `/briefs/${brief.id}`}
        />
        <PaginationControls {...pagy} />
      </div>
    </div>
  );
};

Index.layout = wideLayout;

export default Index;
